import { tagAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools'

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tagAnatomy.keys)

const variants = {
  subtle: definePartsStyle((props: StyleFunctionProps) => {
    const c = props.colorScheme
    const hasCustomColor = c && c !== 'gray'
    return {
      container: {
        bg: hasCustomColor
          ? mode(
              `color-mix(in srgb, var(--chakra-colors-${c}-100) 60%, transparent)`,
              `color-mix(in srgb, var(--chakra-colors-${c}-200) 15%, transparent)`
            )(props)
          : 'bg-muted',
        color: 'default',
        borderRadius: 'full',
      },
    }
  }),
}

export default defineMultiStyleConfig({ variants })
